export default "__VITE_ASSET__005ebdc5__"